import { render, staticRenderFns, recyclableRender, components } from "./u-checkbox.vue?vue&type=template&id=3684d39c&scoped=true&"
var renderjs
import script from "./u-checkbox.vue?vue&type=script&lang=js&"
export * from "./u-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./u-checkbox.vue?vue&type=style&index=0&id=3684d39c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\前端软件\\HBuilderX.3.2.12.20211029\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3684d39c",
  null,
  false,
  components,
  renderjs
)

export default component.exports